import _styled from '@emotion/styled/base';
import Box from '@mui/material/Box';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledPrefixWordContainer = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e15x6vfs0"
})(_ref => {
  let {
    theme
  } = _ref;
  return {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '15px',
    paddingRight: '15px',
    color: theme.customColors.grey[500],
    background: theme.customColors.grey[200]
  };
}, "");
export { StyledPrefixWordContainer };